<template>

  <!-- <dialog_CustomerEdit v-if="ed_dialog_show" :editDialogSwitch="editDialogSwitch" :customer="editingCustomer" :fetchCustomers="fetchCustomers"/> -->
  <dialog_customerRegister v-if="ed_dialog_show" :registerDialogSwitch="editDialogSwitch" :reloadForSync="fetchCustomers"/>

  <div id="dialog-customerPicker">
    <div class="dialog">
      <span class="cls" @click="cancel()"></span>
      <div class="paper customer-picker">
        <div class="header"> <h1>고객정보수정</h1> <span @click="cancel()">X</span> </div>
        
        <!-- 검색 영역 -->
        <div class="search-area">
          <input type="text" placeholder="이름, 연락처로 검색" v-model="searchRef" />
          <i class="ph-bold ph-magnifying-glass"></i>
        </div>

        <!-- 태그 필터 영역 -->
        <div class="filter-area">
          <ul class="tags">
            <li @click="toggleAllTags" :class="{ sel: selectedTags.length === 0 }">전체</li>
            <li
              v-for="tag in myAllTags"
              :key="tag.name"
              :class="{ sel: selectedTags.includes(tag.name) }"
              @click="toggleTag(tag.name)"
            >
              {{ tag.name }}
            </li>
          </ul>
        </div>

        <ul>
          <li class="add" @click="makeCustomer"> <div> <i class="ph-bold ph-plus-circle"></i> <span>고객 추가</span> </div> </li>
          <template v-for="Customer in filteredCustomers" :key="Customer.idx">
            <li :class="Customer.select ? 'selected' : ''" @click="selectCustomerHandler(Customer)">
              <div> <img :src="Customer.thumb"> <span>{{ Customer.name }}</span> </div>
              <div> <span>{{ Customer.phone }}</span> </div>
            </li>
          </template>
        </ul>
        <div class="btns">
          <button class="btn btn-secondary" @click="cancel()">취소</button>
          <button class="btn btn-primary" @click="confirm()">확인</button>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import { inject, ref, computed } from "vue";
// import dialog_CustomerEdit from "@/components/dialogs/customerEdit.vue";
import dialog_customerRegister from '@/components/dialogs/customerRegister.vue';

import { useBackButton } from '@/utils/useBackBtn';


export default {
  emits: ['submit'],
  components: {
    dialog_customerRegister
  },
  setup(props, { emit }) {
    const sql_query = inject('sql_query');
    const CustomerList = ref([]);
    const getMbid = inject('getMbid');
    let basic_profile_url = `/imgs/unknow_user.png`;

    // 검색 및 필터 관련
    const searchRef = ref('');
    const myAllTags = ref([]);
    const selectedTags = ref([]);

    
    useBackButton(() => {
      cancel();
    });

    async function fetchCustomers() {

      const rootSql = `SELECT * FROM customers WHERE mb_id = '${getMbid()}' ORDER BY created_at DESC`;
      const result = await sql_query(rootSql);

      const rootCustomers = Array.isArray(result) ? result : result?.results ? result.results : [];

      if (rootCustomers.length === 0) {
        console.log("No customers found.");
        return;
      }

      CustomerList.value = rootCustomers.map(c => ({
        idx: c.idx,
        name: c.name,
        phone: c.phone,
        nickname: c.nickname,
        mb_id: c.mb_id,
        grade: c.grade,
        m_type: c.m_type,
        sex: c.sex,
        birth: c.birth,
        civ_code: c.rrn,
        address: c.address,
        location: c.location,
        ex_address: c.ex_address,
        job: c.job,
        job_grade: c.job_grade,
        job_name: c.job_name,
        job_adrs: c.job_address,
        family: c.family,
        notes: c.notes,
        extra_info: c.extra_info,
        sns_talk : c.sns_talk,
        sns_ama : c.sns_ama,
        sns_etc: c.sns_etc,
        created_at: c.created_at,
        thumb: c.thumb || basic_profile_url,
        select: false,
        tags: typeof c.tags === 'string' ? JSON.parse(c.tags || '[]') : (c.tags || []),
      }));
    }
    fetchCustomers();

    async function fetchMyTags() {
      let sql = `SELECT * FROM customer_tag WHERE mb_id = '${getMbid()}'`;
      let result = await sql_query(sql);
      myAllTags.value = result;
    }
    fetchMyTags();

    
    // 필터링된 고객 목록 (computed)
    const filteredCustomers = computed(() => {
      const searchValue = (searchRef.value || '').toLowerCase();
      const selected = Array.isArray(selectedTags.value) ? selectedTags.value : [];

      return (Array.isArray(CustomerList.value) ? CustomerList.value : []).filter(customer => {
        if (!customer) return false;

        // 안전 처리
        const name = (customer.name || '').toLowerCase();
        const phone = customer.phone || '';

        // 검색어 매칭
        const matchSearch =
          name.includes(searchValue) ||
          phone.includes(searchValue);

        // 태그 매칭
        const tags = Array.isArray(customer.tags) ? customer.tags : [];
        const matchTags =
          selected.length === 0 ||
          selected.every(tag => tags.includes(tag));

        return matchSearch && matchTags;
      });
    });


    function toggleTag(tag) {
      const index = selectedTags.value.indexOf(tag);
      if (index > -1) {
        selectedTags.value.splice(index, 1);
      } else {
        selectedTags.value.push(tag);
      }
    }

    function toggleAllTags() {
      selectedTags.value = [];
    }

    function selectCustomerHandler(customer) {
      // 기존 선택 모두 해제
      CustomerList.value.forEach(c => c.select = false);
      // 현재 클릭한 고객만 선택
      customer.select = true;
    }

    const ed_dialog_show = ref(false);
    function editDialogSwitch(bool) {
      ed_dialog_show.value = bool;
    }

    const editingCustomer = ref(null);
    function makeCustomer() {
      // editingCustomer.value = {
      //   idx: null,
      //   name: '새 고객',
      //   nickname: '새 고객',
      //   title: "고객님",
      //   m_type: 'X0',
      //   rrn: '19100101-1234567',
      //   birth: '1910-01-01',
      //   sex: '0',
      //   address: '',
      //   location: '',
      //   ex_address: '',
      //   phone: '010-',
      //   job: '',
      //   job_grade: '',
      //   job_name: '',
      //   job_dept: '',
      //   job_address: '',
      //   notes: '',
      //   med_history: '',
      //   tags: '',
      //   is_keyman: '0',
      //   is_offical: '0',
      //   vip_rank : '0',
      //   manage_rank : '0',
      //   extra_info: '',
      //   sns_talk : '',
      //   sns_ama : '',
      //   sns_etc : '',
      //   thumb: basic_profile_url,
      //   opt_visible: true,
      //   last_touch: '',
      // };
      editDialogSwitch(true);
    }

    function confirm() {
      const selected = CustomerList.value.find(c => c.select);

      if (!selected) {
        alert("고객을 선택해주세요.");
        return;
      }

      emit('submit', { customer: selected });
    }


    function cancel() {
      emit('submit', { customer: null })
    }

    return {
      confirm,
      cancel,
      CustomerList,
      selectCustomerHandler,
      editDialogSwitch,
      ed_dialog_show,
      fetchCustomers,
      makeCustomer,
      editingCustomer,
      searchRef,
      myAllTags,
      selectedTags,
      toggleTag,
      toggleAllTags,
      filteredCustomers,
    }
  }
}
</script>


<style scoped>
#dialog-customerPicker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  backdrop-filter: blur(2px);
}
.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width:600px;
  height:80%;
  background: var(--color-background);
  border:1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap:16px;
  display:flex;
  flex-direction: column;
  overflow-y: auto;
}

/* 검색 영역 */
.search-area {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  position: relative;
}

.search-area input[type="text"] {
  width: 100%;
  height: 100%;
  padding: 0 48px 0 16px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  font-size: var(--font-size-md);
  background: var(--color-background-light);
  color: var(--color-text-primary);
}

.search-area > i {
  position: absolute;
  right: 16px;
  font-size: 20px;
  color: var(--color-text-primary);
  opacity: 0.6;
  pointer-events: none;
}

/* 필터 영역 */
.filter-area {
  width: 100%;
}

.tags {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
}

.tags > li {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width:fit-content;
  padding: 0 12px;
  border-radius: 6px;
  font-size: var(--font-size-sm);
  cursor: pointer;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  opacity: 0.6;
  transition: all 0.2s;
}

.tags > li:hover {
  opacity: 1;
}

.tags > li.sel {
  opacity: 1;
  background: var(--color-brand);
  color: var(--color-text-black);
  font-weight: 600;
}

.btns {
  width:100%;
  height:48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap:12px;
}

.btns > button {
  width: 100%;
  height: 100%;
  padding: 0 16px;
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
  background: var(--color-background-light);
  border:none;
  border-radius: 8px;
  cursor: pointer;
}

.btns > button.btn-primary {
  background: var(--color-brand);
  color: var(--color-text-black);
}

ul {
  width:100%;
  height:100%;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
}

/* 스크롤바 전체 영역 */
ul::-webkit-scrollbar {
  width: 8px;
}

/* 스크롤바 트랙(배경) */
ul::-webkit-scrollbar-track {
  background: var(--color-background);
  border-radius: 4px;
}

/* 스크롤바 thumb(움직이는 부분) */
ul::-webkit-scrollbar-thumb {
  background: var(--color-background-light);
  border-radius: 4px;
  transition: all 0.2s;
}

/* 스크롤바 hover */
ul::-webkit-scrollbar-thumb:hover {
  background: var(--color-brand);
}

ul > li {
  width:100%;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 8px;
  gap:12px;
  cursor:pointer;
  padding:6px;
  box-sizing: border-box;
}

ul > li:hover {
  background: var(--color-background-light);
}

ul > li.selected {
  background: var(--color-background-light);
  color: var(--color-text-black);
}

ul > li.add {
  font-weight:700;
  color:var(--color-surface-reverse);
}

ul > li.add i {
  font-size:40px;
}

ul > li.add span {
  color:var(--color-surface-reverse);
}

ul > li.add > button {
  width:100%;
  height:100%;
  padding: 8px 16px;
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
  background: var(--color-background-light);
  border:none;
  border-radius: 8px;
  cursor: pointer;
}

ul > li > div {
  display: flex;
  align-items: center;
  justify-content: center;
  gap:12px;
}

ul > li > div > img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

ul > li > div > span {
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
}

.header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.header > h1 {
  font-size:20px;
}

.header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

/* 태블릿 (768px ~ 1024px) */
@media (min-width: 601px) and (max-width: 1024px) {
  .dialog > .paper {
    width: 90%;
    max-width: 700px;
    height: 85%;
    border-radius: 16px;
    padding: 24px;
  }

  .search-area {
    height: 52px;
  }

  .search-area input[type="text"] {
    font-size: var(--font-size-lg);
  }

  /* 고객 리스트 2컬럼 그리드 */
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    align-content: start;
  }

  ul > li {
    padding: 12px;
    border: 1px solid var(--color-background-light);
    border-radius: 12px;
  }

  ul > li.selected {
    border-color: var(--color-brand);
  }

  /* 고객 추가 버튼 - 전체 너비 */
  ul > li.add {
    grid-column: span 2;
  }

  /* 고객 정보 세로 배치 */
  ul > li:not(.add) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  ul > li > div > img {
    width: 48px;
    height: 48px;
  }

  /* 버튼 영역 */
  .btns {
    height: 52px;
    gap: 16px;
  }

  .btns > button {
    max-width: 200px;
    border-radius: 10px;
  }
}

/* 모바일 (600px 이하) */
@media (max-width: 600px) {
  .dialog > .paper {
    width: 100%;
    max-width: 100%;
    height: 100vh;
    border-radius: 0;
    border: none;
    padding: 16px;
  }

  ul {
    display: flex;
    flex-direction: column;
  }

  ul > li {
    padding: 8px;
  }

  ul > li > div > img {
    width: 36px;
    height: 36px;
  }

  .btns {
    height: 44px;
  }
}

</style>